import { __assign, __extends } from "tslib";
import * as React from 'react';
import { Announced } from '@fluentui/react/lib/Announced';
import { concatStyleSets } from '@fluentui/react/lib/Styling';
import { getDocumentTitleButtonStyles, getDocumentTitleStyles, getDocumentTitleToolTipStyles, } from './DocumentTitle.styles';
import { DocumentTitleCallout } from '../DocumentTitleCallout';
import { KeyCodes } from '@fluentui/react/lib/Utilities';
import { LogCategory, TraceLevel, ULS } from '@ms/office-online-telemetry/lib/';
import { HeaderButton } from '@ms/office-online-shared-header-core/lib';
import { DocumentTitleStatusLabel } from '../DocumentTitleStatusLabel';
import { Icon } from '@fluentui/react/lib/Icon';
import { performOnNextFrame } from '@ms/app-commanding-ui/lib/utilities';
import { sendTelemetryEvent } from '@ms/office-online-otel';
import { TooltipHost, TooltipDelay } from '@fluentui/react/lib/Tooltip';
import { DirectionalHint } from '@fluentui/react';
var DocumentTitle = /** @class */ (function (_super) {
    __extends(DocumentTitle, _super);
    function DocumentTitle(documentTitleProps) {
        var _this = _super.call(this, documentTitleProps) || this;
        _this.suggestedTitleShown = false;
        _this.suggestedTitle = '';
        _this.getDocumentTitleCalloutProps = function (titleProps) {
            var titleCalloutProps = titleProps;
            var isVersionHistoryEnabled = _this.props.isVersionHistoryEnabled;
            if (_this.props.getCalloutAppProps) {
                var calloutAppProps = _this.props.getCalloutAppProps();
                isVersionHistoryEnabled = calloutAppProps.isVersionHistoryEnabled;
                titleCalloutProps = __assign(__assign({}, titleProps), { breadcrumbFolderName: calloutAppProps.breadcrumbFolderName, breadcrumbFolderUrl: calloutAppProps.breadcrumbFolderUrl, breadcrumbBrandName: calloutAppProps.breadcrumbBrandName, breadcrumbBrandUrl: calloutAppProps.breadcrumbBrandUrl, documentExtension: calloutAppProps.documentExtension, message: calloutAppProps.message, hideDocumentTitleInput: calloutAppProps.hideDocumentTitleInput, isMoveEnabled: calloutAppProps.isMoveEnabled, onMove: calloutAppProps.onMove });
            }
            if (_this.props.hideSaveStatus) {
                titleCalloutProps.saveStatus = undefined;
            }
            if (isVersionHistoryEnabled !== true) {
                titleCalloutProps.versionHistoryButtonProps = undefined;
            }
            return titleCalloutProps;
        };
        _this.getSuggestedTitle = function () {
            if (_this.suggestedTitleShown) {
                return undefined;
            }
            return _this.suggestedTitle;
        };
        _this.renderSaveStatus = function () {
            var _a = _this.props, saveStatus = _a.saveStatus, mode = _a.mode, hideMode = _a.hideMode, hideSaveStatus = _a.hideSaveStatus;
            return (React.createElement(DocumentTitleStatusLabel, { mode: mode, hideMode: hideMode, hideSaveStatus: hideSaveStatus, saveStatus: saveStatus, strings: _this.props.strings }));
        };
        _this.renderButton = function (documentTitleStyles) {
            var _a = _this.props, documentTitle = _a.documentTitle, colors = _a.colors;
            var buttonStyles = getDocumentTitleButtonStyles(colors);
            if (_this.props.buttonStyles) {
                buttonStyles = concatStyleSets(buttonStyles, _this.props.buttonStyles);
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(HeaderButton, { id: _this.props.id, colors: colors, onClick: _this.onHeaderClick, onKeyUp: _this.onDocumentTitleKeyUp, styles: buttonStyles, "data-unique-id": "DocumentTitleButton", "aria-expanded": _this.state.isCalloutVisible },
                    React.createElement("span", { "data-unique-id": "DocumentTitleContent", className: documentTitleStyles.documentTitle }, documentTitle),
                    _this.props.isShared && (React.createElement(TooltipHost, { tooltipProps: {
                            onRenderContent: function () { return React.createElement("span", null, _this.props.strings.sharedStatusTooltip); },
                        }, delay: TooltipDelay.zero, id: "SharedStatusToolTip", directionalHint: DirectionalHint.bottomCenter, styles: getDocumentTitleToolTipStyles() },
                        React.createElement("span", null,
                            React.createElement(Icon, __assign({ className: documentTitleStyles.sharedIcon }, _this.props.icons.shared))))),
                    _this.renderSaveStatus(),
                    React.createElement("span", null,
                        React.createElement(Icon, __assign({ className: documentTitleStyles.chevron }, _this.props.icons.chevronDown)))),
                !!documentTitle &&
                    !!_this.props.strings.documentNameUpdatedAnnouncement &&
                    _this.state.announceDocumentRenamed && (React.createElement(Announced, { "aria-live": "polite", message: _this.props.strings.documentNameUpdatedAnnouncement.replace('{0}', documentTitle) }))));
        };
        _this.onDocumentTitleKeyUp = function (ev) {
            if (ev.which === KeyCodes.down && (ev.altKey || ev.metaKey)) {
                ev.preventDefault();
                ev.stopPropagation();
                _this.showCallout('altkey');
            }
        };
        _this.onHeaderClick = function () {
            _this.showCallout('click');
        };
        _this.showCallout = function (source) {
            _this.onShowCallout(source);
            _this.setState(function (prevState) {
                return { isCalloutVisible: !prevState.isCalloutVisible };
            }, function () {
                _this.suggestedTitleShown = _this.suggestedTitleShown || !!_this.suggestedTitle;
            });
        };
        _this.onShowCallout = function (source) {
            if (!_this.state.isCalloutVisible) {
                if (_this.props.onCalloutOpen) {
                    _this.props.onCalloutOpen();
                }
                else {
                    ULS.sendTraceTag(0x2364f2a2 /* tag_9zpk8 */, LogCategory.msoulscat_Wac_Ribbon, TraceLevel.Warning, "TypeOfOnCalloutOpen: " + typeof _this.props.onCalloutOpen + ", TypeOfOnCalloutClose:" + typeof _this.props
                        .onCalloutClose + ", IsDocumentTitleDefined:" + !!_this.props.documentTitle);
                }
                if (!_this.suggestedTitleShown && _this.props.onGetSuggestedTitle) {
                    _this.suggestedTitle = _this.props.onGetSuggestedTitle();
                }
                var renameDisableReason = null;
                if (_this.props.readOnlyDocumentTitleInput && _this.props.getCalloutAppProps) {
                    var calloutAppProps = _this.props.getCalloutAppProps();
                    renameDisableReason = calloutAppProps.renameDisableReason;
                }
                sendTelemetryEvent({
                    name: 'Office.FileIO.Online.DTT.CalloutOpened',
                    dataFields: [
                        { name: 'RenameEnabled', bool: !_this.props.readOnlyDocumentTitleInput },
                        { name: 'RenameDisableReason', string: renameDisableReason },
                        { name: 'Source', string: source },
                    ],
                });
            }
        };
        _this.closeCallout = function () {
            _this.setState({
                isCalloutVisible: false,
            });
            if (_this.props.onCalloutClose) {
                _this.props.onCalloutClose();
            }
        };
        _this.menuButtonRef = React.createRef();
        _this.state = {
            isCalloutVisible: false,
            announceDocumentRenamed: false,
        };
        if (_this.props.isCalloutOpen) {
            _this.state = __assign(__assign({}, _this.state), { isCalloutVisible: true });
            _this.onShowCallout('prop');
        }
        return _this;
    }
    DocumentTitle.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isCalloutOpen !== prevProps.isCalloutOpen && this.props.isCalloutOpen) {
            this.showCallout('prop');
        }
        // Update the state on first rename so that we render the Announced component
        // This will keep re-rendering on subsequent updates which is ok since the browser will not
        // reannounce updates since the content will not change until the next rename
        if (this.props.documentTitle !== prevProps.documentTitle) {
            this.setState({
                announceDocumentRenamed: true,
            });
        }
    };
    DocumentTitle.prototype.componentDidMount = function () {
        if (this.props.onFirstRender) {
            performOnNextFrame(this.props.onFirstRender);
        }
    };
    DocumentTitle.prototype.render = function () {
        var colors = this.props.colors;
        var documentTitleStyles = getDocumentTitleStyles(colors);
        return (React.createElement("div", { className: documentTitleStyles.documentTitleContainer },
            React.createElement("div", { className: documentTitleStyles.buttonWrapper, ref: this.menuButtonRef }, this.renderButton(documentTitleStyles)),
            this.state.isCalloutVisible && (React.createElement(DocumentTitleCallout, __assign({}, this.getDocumentTitleCalloutProps(__assign(__assign({}, this.props), { menuButtonElement: this.menuButtonRef, closeCallout: this.closeCallout, suggestedDocumentTitle: this.getSuggestedTitle() })))))));
    };
    return DocumentTitle;
}(React.PureComponent));
export { DocumentTitle };
//# sourceMappingURL=DocumentTitle.js.map